import { render, staticRenderFns } from "./AboutSessionModal.vue?vue&type=template&id=55adae98&scoped=true&"
import script from "./AboutSessionModal.vue?vue&type=script&lang=js&"
export * from "./AboutSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./AboutSessionModal.vue?vue&type=style&index=0&id=55adae98&prod&lang=scss&"
import style1 from "./AboutSessionModal.vue?vue&type=style&index=1&id=55adae98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55adae98",
  null
  
)

export default component.exports